const typography = {
  primary: "Switzer",
  secondary: "Poppins",
  tertiary: "Inter",
  quartenary: "Noto Sans",
};

export default typography;
